define('appkit/configurator',[
  'underscore',
  'backbone',
  'marionette',
  './radio.mixin'
], function(
  _,
  Backbone,
  Mn,
  RadioMixin
) {

  function Configurator(app) {
    this.app = app;
    this.channel = this.app.channel;
    this._initRadio(this.channel, this.events, {});
  };

  Configurator.extend = Backbone.Model.extend;

  _.extend(Configurator.prototype, Backbone.Events, RadioMixin, {

    configure: function() {
      var args = _.toArray(arguments);
      this.triggerMethod.apply(this, ['before:configure'].concat(args));
      this.triggerMethod.apply(this, ['configure'].concat(args));
      return this;
    },

    triggerMethod: Mn.triggerMethod

  });

  return Configurator;
});

